import { render, staticRenderFns } from "./Attendance.vue?vue&type=template&id=5b3ad45c&scoped=true"
import script from "./Attendance.vue?vue&type=script&lang=js"
export * from "./Attendance.vue?vue&type=script&lang=js"
import style0 from "./Attendance.vue?vue&type=style&index=0&id=5b3ad45c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3ad45c",
  null
  
)

export default component.exports